import { Section } from "@/types/section"

export const leftContentDuration = (section: Section, completedContents: string[]) => {
  let totalDurationVideo = -1
  let totalDurationReading = -1
  let totalDurationQuiz = -1
  let numOfQuizzes = -1

  if (section) {
    for (const eachLecture of section.lectures) {
      for (const eachContent of eachLecture.contents) {
        if(totalDurationVideo < 0 && eachContent.type === 'video'){
          totalDurationVideo = 0;
        }
        if(totalDurationReading < 0 && ['reading', 'pdf', 'notebook'].some((category) => category === eachContent.type)){
          totalDurationReading = 0;
        }
        if(totalDurationQuiz < 0 && ['quiz', 'assignment'].some((category) => category === eachContent.type)){
          totalDurationQuiz = 0;
        }
        if (eachContent.duration && !completedContents.includes(eachContent._id)) {
          if (eachContent.type === 'video') {
            totalDurationVideo = (totalDurationVideo < 0 ? 0 : totalDurationVideo) + Number(eachContent.duration)
          }
          if (['reading', 'pdf', 'notebook'].some((category) => category === eachContent.type)) {
            totalDurationReading = totalDurationReading + Number(eachContent.duration)
          }
          if (['quiz', 'assignment'].some((category) => category === eachContent.type)) {
            totalDurationQuiz = (totalDurationQuiz < 0 ? 0 : totalDurationQuiz) + Number(eachContent.duration)
            numOfQuizzes+=1;
          }
        }
      }
    }
  }

  const formatDuration = (duration: number): string => {
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;
    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}m`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${minutes}m`;
    }
  };

  return {
    totalDurationVideo: formatDuration(totalDurationVideo),
    totalDurationReading: formatDuration(totalDurationReading),
    totalDurationQuiz: formatDuration(totalDurationQuiz),
    totalQuizzes: numOfQuizzes,
  };
}